import {
  post_request,
  get_request_export
} from '../axiosFun'

//查询保养日志列表
export const get_maintenanceLog_list = (params) => {
  params = {
    row: {
      vin: params.vin,
      maintenance_person: params.maintenance_person,
      phone: params.phone,
      maintenance_date: params.maintenance_time_str,
      page_no: params.page,
      page_size: params.limit
    }
  }
  return post_request("/web/projectMaintenanceLog/queryList", params)
}
//添加保养日志
export const get_maintenanceLog_add = (params) => {
  params = {
    row: {
      vin: params.vin,
      maintenance_person: params.maintenance_person,
      phone: params.phone,
      maintenance_content: params.maintenance_content,
      maintenance_time: params.maintenance_time_str,
    }
  }
  return post_request("/web/projectMaintenanceLog/add", params)
}
//获取单条保养日志
export const get_maintenanceLog_one = (params) => {
  params = {
    row: {
      id: params
    }
  }
  return post_request("/web/projectMaintenanceLog/getOne", params)
}
//编辑保养日志
export const get_maintenanceLog_edit = (params) => {
  params = {
    row: {
      id: params.id,
      vin: params.vin,
      maintenance_person: params.maintenance_person,
      phone: params.phone,
      maintenance_content: params.maintenance_content,
      maintenance_time: params.maintenance_time_str,
    }
  }
  return post_request("/web/projectMaintenanceLog/update", params)
}
//获取单条保养日志
export const get_maintenanceLog_del = (params) => {
  params = {
    row: {
      id: params
    }
  }
  return post_request("/web/projectMaintenanceLog/delete", params)
}
//获取车辆列表
export const get_carVin_list = (params) => {
  params = {
    row: {

    }
  }
  return post_request("/web/projectMaintenanceLog/get_vins", params)
}
//导出保养日志
export const get_export_maintenanceLog = (params) => {
  params = {
    row: {
        ids: params
    }
  }
  return get_request_export("/web/projectMaintenanceLog/exportIds", params)
}



// WEBPACK FOOTER //
// ./src/api/projectLog/maintenanceLog.js